/**
 * Window event fired by clearAllUserData (lib/keycloak.ts) when a signed-out
 * user's data is cleared. Kept in its own module so listeners (the vault
 * popup relay) do not depend on the Keycloak module, which many tests mock.
 */
export const USER_DATA_CLEARED_EVENT = 'androcrew:user-data-cleared';
